import { render, staticRenderFns } from "./ui-copy-textarea.vue?vue&type=template&id=f3b9b0ee&scoped=true&"
import script from "./ui-copy-textarea.vue?vue&type=script&lang=ts&"
export * from "./ui-copy-textarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b9b0ee",
  null
  
)

export default component.exports